import { FormGroup, FormParagraph } from '@ksyos/design-system';
import type { IRequestGetOne } from '../../../../interfaces/requestGetOne';
import { CustomControlCollapseBody } from '../../utils/v1/CustomControlCollapseBody';
import { ProfileImages } from '../../utils/v1/ProfileImages';

interface ICustomControlRequestReadInnerProps {
    isOpen: boolean;
    onToggle: (isOpened: boolean) => void;
    orthCRequestReadData: IOrthCV1RequestReadData;
    request?: IRequestGetOne;
}

interface IOrthCV1RequestReadData {
    question: string | null;
    toelichting: string | null;
}

export function OrthCV1RequestReadInner(props: ICustomControlRequestReadInnerProps) {
    if (!props.orthCRequestReadData) {
        return null;
    }

    return (
        <CustomControlCollapseBody isOpen={props.isOpen}>
            {props.request && <ProfileImages request={props.request} />}

            {props.orthCRequestReadData.question && (
                <FormGroup label="Vraag">
                    <FormParagraph>{props.orthCRequestReadData.question}</FormParagraph>
                </FormGroup>
            )}

            {props.orthCRequestReadData.toelichting && (
                <FormGroup label="Toelichting">
                    <FormParagraph>{props.orthCRequestReadData.toelichting}</FormParagraph>
                </FormGroup>
            )}
        </CustomControlCollapseBody>
    );
}
